import {Alert, AlertDescription} from '@/components/ui/alert.tsx';
import {Empty, EmptyDescription, EmptyHeader, EmptyTitle} from '@/components/ui/empty.tsx';
import {LoadingSpinner} from '../../../components/LoadingSpinner';
import {UnitEconomicsWaterfall} from '../unit-economics-page/waterfall/unit-economics-waterfall';
import {useProductPageContext} from './product-context';

export function ProductUnitPage() {
	const state = useProductPageContext();
	if (!state.product?.ozonSku) {
		return (
			<Empty className="border border-border">
				<EmptyHeader>
					<EmptyTitle>Нет SKU Ozon</EmptyTitle>
					<EmptyDescription>Юнит-экономику для этого товара посчитать нельзя</EmptyDescription>
				</EmptyHeader>
			</Empty>
		);
	}
	return (
		<section className="flex flex-col gap-3">
			<h2 className="text-base font-medium">Unit-экономика</h2>
			{state.unitEconomicsError ? (
				<Alert variant="destructive">
					<AlertDescription>{state.unitEconomicsError}</AlertDescription>
				</Alert>
			) : null}
			{state.unitEconomicsLoading ? <LoadingSpinner compact/> : null}
			{state.unitEconomics ? (
				<div className="flex flex-col gap-3">
					<UnitEconomicsWaterfall
						row={state.unitEconomics}
						reportingPeriod={{from: state.unitEconomics.from, to: state.unitEconomics.to}}
					/>
					{state.unitEconomics.warnings.map((warning) => (
						<p key={warning} className="text-sm text-muted-foreground">{warning}</p>
					))}
				</div>
			) : null}
		</section>
	);
}
